<template>
	<Layout>
		<div class="row">
			<div class="col-12">
				<div class="page-title-box d-flex align-items-center justify-content-between icon-main-page">
					<div class="page-title-left avatar-main-icon">
						<div class="avatar-xs mr-3">
							<span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
								<i class="bx bx-purchase-tag"></i>
							</span>
						</div>
						<div class="report-tag">
							<h4 class="mb-0 font-size-18">
								{{ trans.get("__JSON__.Photo & Video Gallery") }}
							</h4>
							<p>{{ trans.trans("__JSON__.Photo & Video Gallery") }}</p>
						</div>
					</div>
				</div>
			</div>

			<div class="col-12">
				<div class="card">
					<div class="text-center text-danger cart-loader" style="height: calc(100vh - 30vh) !important;" v-if="action && action == 'update' && loading">
						<b-spinner class="align-middle mr-2"></b-spinner>
						<strong>{{trans.get('__JSON__.Uploading')}} {{ typeform.type == '0' ? 'Image...' : 'Vibes...' }}</strong>
					</div>

					<div class="text-center text-danger cart-loader" style="height: calc(100vh - 30vh) !important;" v-else-if="action && action == 'delete' && loading">
						<b-spinner class="align-middle mr-2"></b-spinner>
						<strong>{{trans.get('__JSON__.Deleting')}} {{ typeform.type == '0' ? 'Image...' : 'Vibes...' }}</strong>
					</div>

					<div class="card-body">
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label class="control-label">{{ trans.get('__JSON__.Restaurant') }}</label>
									<div class="search-box mr-2 d-inline-block w-100">
										<div class="position-relative">
											<multiselect
											v-model="$v.typeform.selectedRestaurant.$model"
											id="ajax"
											v-bind:disabled="typeform.checkbox"
											label="name"
											track-by="name"
											:placeholder="
												trans.trans('__JSON__.Vendor Search', {
												vendor: $auth.setting.restaurant_name,
												})
											"
											open-direction="bottom"
											:options="resturant"
											:multiple="true"
											:searchable="true"
											:internal-search="true"
											:clear-on-select="false"
											:close-on-select="false"
											:options-limit="30"
											:limit="100"
											:max-height="600"
											:show-no-results="false"
											:hide-selected="true"
											@search-change="asyncFind"
											:class="{
												'is-invalid': $v.typeform.selectedRestaurant.$error,
											}"
											>
											<template slot="tag" slot-scope="{ option, remove }">
												<span class="custom__tag">
												<span>{{ option.name }}</span>
												<span
													class="custom__remove"
													@click="remove(option)"
													>❌</span
												>
												</span>
											</template>
											<template slot="clear" slot-scope="props">
												<div
												class="multiselect__clear"
												v-if="selectedRestaurant.length"
												@mousedown.prevent.stop="clearAll(props.search)"
												></div>
											</template>
											<template slot="noOptions">
												<span>{{ trans.get("__JSON__.Search...") }}.</span>
											</template>
											<template slot="noResult">
												<span
												>{{
													trans.get(
													"__JSON__.Oops! No elements found. Consider changing the search query"
													)
												}}.</span
												>
											</template>
											</multiselect>
											<div
												v-if="$v.typeform.selectedRestaurant.$error"
												class="invalid-feedback"
												>
													<span v-if="!$v.typeform.selectedRestaurant.required"
													>{{
													trans.get("__JSON__.Vendor Select Error", {
														vendor: $auth.setting.restaurant_name,
													})
													}}.</span
												>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="col-md-4">
								<div class="form-group">
									<label class="control-label">{{ trans.get('__JSON__.Type') }}</label>
									<select
										class="custom-select"
										v-model="typeform.type"
										id="type"
										name="type"
										>
										<option value="0" selected>{{ trans.get('__JSON__.Image') }}</option>
										<option value="1">{{ trans.get('__JSON__.Vibes') }}</option>
									</select>
								</div>
							</div>

							<div class="col-md-4">
								<div class="form-group">
									<label class="control-label"></label>
									<div class="mt-1">
										<b-button
											variant="danger"
											v-if="
												$auth.hasPermission(
												config.permissions.gallary_write
												)
											"
											@click="deleteGallaryItems"
											:title="trans.get('__JSON__.Click to delete all photos or videos for the selected restaurants')"
											>{{ trans.get("__JSON__.Delete") }}</b-button
											>
									</div>
								</div>
							</div>

						</div>
						<div class="row">
							<template v-if="typeform.type == 1">
								<div class="col-md-12">
									<h4 class="card-title mt-5">{{ trans.trans("__JSON__.Vibes") }}</h4>
									<div class="row">
										<div class="col-sm-12 imgUp">
											<dropzone-popup
												multiple
												v-model="$v.typeform.vibes.$model"
												id="multiple_videos"
												name="multiple_videos"
												:custom-params="{ 'type': 'multiple' }"
												acceptedFiles="video/*"
												:delete-videos-path="delete_video"
												@video-deleted="this.deleteVideo"
												:upload-type="this.upload_type"
												:class="{
												'is-invalid': $v.typeform.vibes.$error,
											}"
											/>
											<div v-if="$v.typeform.vibes.$error && this.action == 'update'" class="invalid-feedback">
												<span v-if="!$v.typeform.vibes.required">{{ trans.get("__JSON__.Select video") }}.</span>
											</div>
										</div>
									</div>
								</div>
							</template>
							<template v-else>
								<div class="col-sm-12 imgUp">
									<h4 class="card-title mt-5">{{ trans.trans("__JSON__.Photos") }}</h4>
									<dropzone-popup
										multiple
										v-model="$v.typeform.multiple_images.$model"
										id="multiple_images"
										name="multiple_images"
										acceptedFiles=".jpeg,.jpg,.png"
										:custom-params="{ 'type': 'multiple' }"
										:maxFiles="10"
										:class="{
												'is-invalid': $v.typeform.multiple_images.$error,
										}"
										/>
										<div v-if="$v.typeform.multiple_images.$error && this.action == 'update'" class="invalid-feedback">
											<span v-if="!$v.typeform.multiple_images.required">{{ trans.get("__JSON__.Select photo") }}.</span>
										</div>
								</div>
							</template>
						</div>

						<div class="row">
							<div class="col-md-12">
								<div class="btn-update">
									<div class="col-sm-6">
										<b-button
										variant="primary"
										v-if="
											$auth.hasPermission(
											config.permissions.gallary_write
											)
										"
										@click="storeGallaryItems()"
										class="float-left mr-1 mt-3"
										>{{ trans.get("__JSON__.Update") }}</b-button
										>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
	import vue2Dropzone from "vue2-dropzone";
	import Multiselect from "vue-multiselect";
	import PageHeader from "../../components/page-header";
	import Layout from "../../layouts/main";
	import { promoCodeService, bannerService, restaurantService } from "../../services";
	import { error_message, success_message } from "../../Helper/helper";
	import config from "../../config";

	import { routes } from "../../config/api_routes";
	import DropzonePopup from "../../components/widgets/dropzone-popup";
	import { required, requiredIf } from "vuelidate/lib/validators";
	import Swal from "sweetalert2";

	export default {
		components: {
			vueDropzone: vue2Dropzone,
			Multiselect,
			PageHeader,
			bannerService,
			DropzonePopup,
			Layout,
		},
		data() {
			return {
				config: config,
      			resturant: [],
				selectedRestaurant : [],
				typeform: {
					selectedRestaurant: "",
					type : '0',
					vibes : [],
					multiple_images : []
				},
				delete_video: routes.deleteVideoUrl,
				loading: false,
				action: "",
				newData: false,
				upload_type : 'video',
			};
		},
		validations: {
			typeform: {
				selectedRestaurant: {
					required,
				},
				type :{
					required
				},
				multiple_images: {
					required: requiredIf(function(form){
						console.log("form",form);
						
						return form.type && form.type == '0';
					})
				},
				vibes: {
					required: requiredIf(function(form){
						return form.type && form.type == '1';
					})
				},
			},
		},
		methods: {
			clearAll() {
				this.selectedRestaurant = [];
			},
			asyncFind(query) {
				this.isLoading = true;
				bannerService.getRestaurant(query).then((response) => {
					this.resturant = response.data.result;
					this.isLoading = false;
				});
			},
			storeGallaryItems() {
				this.action = 'update';
				this.$v.$touch();
				if (this.$v.typeform.$invalid) {
					return;
				}

				this.loading = true;
				
				const fd = new FormData();

				this.typeform.selectedRestaurant
					.map((item) => item.restaurant_id)
					.map((item, index) => {
						fd.append("selectedRestaurant[" + index + "]", item);
				});

				if(this.typeform.vibes && Array.isArray(this.typeform.vibes)){
					this.typeform.vibes.forEach((item, index) => {
						fd.append(`multiple_videos[${index}][video]`, item.video);
						fd.append(`multiple_videos[${index}][thumbnail]`, item.thumbnail);
					});
				}
				
				if(this.typeform.multiple_images && Array.isArray(this.typeform.multiple_images)){
					this.typeform.multiple_images.forEach(file => {
						fd.append('multiple_images[]', file);
					});
				}

				fd.append('type', this.typeform.type);

				restaurantService.storeGallaryItems(fd)
				.then((response) => {
					if (response.data.code === 200) {
						location.reload();
						success_message(response.data.message);
					} else {
						error_message(response.data.message);
					}
				})
				.catch((error) => {
					this.loading = false;
					console.log(error);
					
					error_message(error);
				});
			},
			deleteGallaryItems() 
			{
				this.$v.$touch();				
				if (this.$v.typeform.selectedRestaurant.$invalid) {
					return;
				}
				let type = this.typeform.type == '1' ? 'vibes' : 'images';
				Swal.fire({
					title: "Are you sure you want to delete " + type + " ?",
					text: "You won't be able to revert this!",
					icon: "warning",
					showCancelButton: true,
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
					confirmButtonText: "Yes, delete it!",
				}).then((result) => {
					if (result.isConfirmed) 
					{
						this.loading = true;
						this.action = 'delete';
						const fd = new FormData();
						this.typeform.selectedRestaurant
							.map((item) => item.restaurant_id)
							.map((item, index) => {
							fd.append("selectedRestaurant[" + index + "]", item);
						});

						fd.append('type', this.typeform.type);

						restaurantService.deleteGallaryItems(fd)
						.then((response) => {
							if (response.data.code === 200) {
								this.loading = false;
								success_message(response.data.message);
							} else {
								this.loading = false;
								error_message(response.data.message);
							}
						})
						.catch((error) => {
							this.loading = false;
							console.log(error);
							
							error_message(error);
						});
					}
				});
			},
			deleteVideo(value){
				this.typeform.vibes = typeform.vibes.filter(doc => doc.id !== value);
			},
		}
	
	};
</script>